/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Usage_Scope_NoteInputs */



/**
* | output |
* | --- |
* | "Aggregated usage only — no chat titles or contents are shown here." |
*
* @param {Member_Usage_Scope_NoteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_usage_scope_note = /** @type {((inputs?: Member_Usage_Scope_NoteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Usage_Scope_NoteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur aggregierte Nutzung — Chat-Titel und -Inhalte werden hier nicht angezeigt.")
	return /** @type {LocalizedString} */ ("Aggregated usage only — no chat titles or contents are shown here.")
});